<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

@if (formLoading) {
  <div>
    <mat-spinner></mat-spinner>
  </div>
}

<h2>{{formTitle}}</h2>

<form [formGroup]="form1">
  <div class="col-lg-12">
    <span class="p-float-label required-field w-100 mb-3">
      <input formControlName="newFeatureName" id="newFeatureName" type="text" pInputText>
      <label for="newFeatureName">New Feature Name</label>
    </span>
    @for (validation of validationMessages.newFeatureName; track validation) {
      <span>
        @if (form1.get('newFeatureName').hasError(validation.type) && (form1.get('newFeatureName').dirty || form1.get('newFeatureName').touched)) {
          <small class="p-invalid"
            >{{validation.message}}
          </small>
        }
      </span>
    }
  </div>
  <div class="col-lg-12">
    <span class="p-float-label w-100 mb-2">
      <textarea formControlName="newFeatureDesc" id="newFeatureDesc" [rows]="4" pInputTextarea></textarea>
      <label for="newFeatureDesc">New Feature Description</label>
    </span>
    @for (validation of validationMessages.newFeatureDesc; track validation) {
      <span>
        @if (form1.get('newFeatureDesc').hasError(validation.type) && (form1.get('newFeatureDesc').dirty || form1.get('newFeatureDesc').touched)) {
          <small class="p-invalid"
            >{{validation.message}}
          </small>
        }
      </span>
    }
  </div>


  <div class="col-lg-12">
    <span class="p-float-label required-field w-100 mb-3">
      <p-dropdown [options]="highlights" formControlName="newHighlight" optionLabel="name" optionValue="value"
        placeholder="Highlight" [ngStyle]="{'minWidth':'175px'}">
      </p-dropdown>
      <label for="Highlight">Highlight</label>
      @for (validation of validationMessages.newHighlight; track validation) {
        <span>
          @if (form1.get('newHighlight').hasError(validation.type) && (form1.get('newHighlight').dirty || form1.get('newHighlight').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>

  <div class="col-lg-12">
    <span class="p-float-label required-field w-100 mb-3">
      <input formControlName="newQuantity" id="newQuantity" type="text" pInputText>
      <label for="newHighlight">Quantity</label>
    </span>
    @for (validation of validationMessages.newQuantity; track validation) {
      <span>
        @if (form1.get('newQuantity').hasError(validation.type) && (form1.get('newQuantity').dirty || form1.get('newQuantity').touched)) {
          <small class="p-invalid"
            >{{validation.message}}
          </small>
        }
      </span>
    }
  </div>

  <div class="col-lg-12">
    <span class="p-float-label required-field w-100 mb-3 d-flex" style="column-gap: 15px;">
      <input formControlName="newDistance" id="newDistance" type="text" pInputText>
      <label for="newDistance">Distance</label>
      @for (validation of validationMessages.newDistance; track validation) {
        <span>
          @if (form1.get('newDistance').hasError(validation.type) && (form1.get('newDistance').dirty || form1.get('newDistance').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }

      <p-dropdown [options]="distanceUnits" formControlName="newDistanceUnit" optionLabel="name" optionValue="value"  appendTo="body"
        placeholder="Distance Unit">
      </p-dropdown>
      <label for="Distance Unit">Distance Unit</label>
      @for (validation of validationMessages.newDistanceUnit; track validation) {
        <span>
          @if (form1.get('newDistanceUnit').hasError(validation.type) && (form1.get('newDistanceUnit').dirty || form1.get('newDistanceUnit').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
  <hr>
    <h4>{{actionLabel}} To:</h4>
    <div class="d-flex flex-wrap" style="column-gap: 15px;">
      <span class="my-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'" appendTo="body"
          [options]="locations" formControlName="formLocationIds" defaultLabel="Select Location"
          dataKey="locationId" optionLabel="name" display="chip">
        </p-multiSelect>
        @for (validation of validationMessages.formLocationIds; track validation) {
          <span>
            @if (form1.get('formLocationIds').hasError(validation.type) && (form1.get('formLocationIds').dirty || form1.get('formLocationIds').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>

      <span class="my-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'" appendTo="body"
          [options]="developments" formControlName="formDevelopmentIds" defaultLabel="Select Resort"
          dataKey="developmentId" optionLabel="addressDevelopmentName" display="chip">
        </p-multiSelect>
        @for (validation of validationMessages.formDevelopmentIds; track validation) {
          <span>
            @if (form1.get('formDevelopmentIds').hasError(validation.type) && (form1.get('formDevelopmentIds').dirty || form1.get('formDevelopmentIds').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>

      <span class="my-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'" appendTo="body"
          [options]="shortTermRentals" formControlName="formShortTermRentalIds" defaultLabel="Select Property"
          dataKey="shortTermRentalId" optionLabel="propertyCode" display="chip">
        </p-multiSelect>
        @for (validation of validationMessages.formShortTermRentalIds; track validation) {
          <span>
            @if (form1.get('formShortTermRentalIds').hasError(validation.type) && (form1.get('formShortTermRentalIds').dirty || form1.get('formShortTermRentalIds').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>

      <span class="my-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'" appendTo="body"
          [options]="bedrooms" formControlName="formBedrooms" defaultLabel="Select Bedrooms" dataKey="id"
          optionLabel="name" display="chip">
        </p-multiSelect>
        @for (validation of validationMessages.formBedrooms; track validation) {
          <span>
            @if (form1.get('formBedrooms').hasError(validation.type) && (form1.get('formBedrooms').dirty || form1.get('formBedrooms').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>

      <p-button label="{{actionLabel}}" (click)="copyFeatureClick()" class="my-2 d-block"></p-button>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button pButton pRipple type="button" label="Reset" class="p-button-warning p-button-text my-2 d-block"
      (click)="form1.reset();"></button>
    </div>
  </form>
